import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { validateImageUrl } from "../../../../global-account/react/utils/profileDisplay.js";
import { AVATAR_COLORS } from "../../../../shared/constants/index.js";
import Avatar from "boring-avatars";
import { useCallback, useEffect, useState } from "react";
import { IPFSMediaRenderer } from "../IPFSMediaRenderer/IPFSMediaRenderer.js";
/**
 * Renders a user avatar with IPFS support and boring-avatars fallback.
 *
 * - If `avatarUrl` is provided and valid, renders via IPFSMediaRenderer.
 * - On load failure or missing URL, falls back to a deterministic boring-avatars beam.
 */
export function UserAvatar(t0) {
  const $ = _c(4);
  const {
    avatarUrl,
    name: t1,
    size: t2,
    className
  } = t0;
  const name = t1 === undefined ? "user" : t1;
  const size = t2 === undefined ? 40 : t2;
  const resolvedSrc = validateImageUrl(avatarUrl);
  const [imgError, setImgError] = useState(false);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setImgError(false);
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== avatarUrl) {
    t4 = [avatarUrl];
    $[1] = avatarUrl;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  useEffect(t3, t4);
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setImgError(true);
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const handleImgError = t5;
  return _jsx("div", {
    className,
    style: {
      width: size,
      height: size,
      minWidth: size,
      minHeight: size
    },
    children: resolvedSrc && !imgError ? _jsx("div", {
      onErrorCapture: handleImgError,
      className: "h-full w-full overflow-hidden rounded-full",
      children: _jsx(IPFSMediaRenderer, {
        src: resolvedSrc,
        alt: name,
        className: "h-full w-full object-cover"
      })
    }) : _jsx(Avatar, {
      name,
      variant: "beam",
      size,
      colors: AVATAR_COLORS
    })
  });
}